// import { useLocaleText } from '@mui/x-date-pickers/internals';
import { usePickersTranslations } from "@mui/x-date-pickers/hooks";
import DialogActions from "@mui/material/DialogActions";
import { Button } from "@mui/material";
import { useViewport } from "./screen-size-hooks";

export function ActionsPicker(props) {
  const { width } = useViewport();
  const { onAccept, onClear, onCancel, actions, className } = props;
  const localeText = usePickersTranslations();

  if (actions == null || actions.length === 0) {
    return null;
  }

  return (
    <DialogActions
      className={className}
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <Button
        onClick={() => {
          onClear();
        }}
      >
        {localeText.clearButtonLabel}
      </Button>
      <Button
        onClick={() => {
          onCancel();
        }}
      >
        {localeText.cancelButtonLabel}
      </Button>
      {width <= 768 && (
        <Button
          onClick={() => {
            onAccept();
          }}
        >
          {localeText.okButtonLabel}
        </Button>
      )}
    </DialogActions>
  );
}
